export enum UsersPermissions {
    GetUser = 'users.read',
    CreateUser = 'users.create',
    UpdateUser = 'users.update',
    DeleteUser = 'users.delete',
}

export enum OrganizationPermissions {
    GetOrganization = 'organizations.read',
    CreateOrganization = 'organizations.create',
    UpdateOrganization = 'organizations.update',
    DeleteOrganization = 'organizations.delete',
    // Invites
    AddInvites = 'organizations.invites.create',
    ListInvites = 'organizations.invites.read',
    UpdateInvites = 'organizations.invites.update',
    DeleteInvites = 'organizations.invites.delete',
    // Users
    ListUsers = 'organizations.users.read',
    AddUsers = 'organizations.users.create',
    UpdateUsers = 'organizations.users.update',
    DeleteUsers = 'organizations.users.delete',
    UpdateDriverUsers = 'organizations.users.drivers.update',
    DeleteDriverUsers = 'organizations.users.drivers.delete',
    OrganizationsInvitesDriversCreate = 'organizations.invites.drivers.create',
    OrganizationsInvitesDriversUpdate = 'organizations.invites.drivers.update',
    OrganizationsInvitesDriversDelete = 'organizations.invites.drivers.delete',
}

export enum AdminPermission {
    HasAdminPrivilege = 'admin',
}
